export const PX = {
  navPxMaster: "nav-px-master",
  page: "px-master-page",
  title: "px-master-title",
  banner: "px-master-banner",
  search: "px-master-search",
  table: "px-master-table",
  loading: "px-master-loading",
  emptyState: "px-master-empty",
  errorState: "px-master-error",
  row: "px-master-row",
  newBtn: "px-master-new-btn",
  editBtn: "px-master-edit-btn",
  activateBtn: "px-master-activate-btn",
  form: "px-master-form",
  formLocalCode: "px-master-field-local-code",
  formDisplay: "px-master-field-display",
  formShortDisplay: "px-master-field-short-display",
  formDescription: "px-master-field-description",
  formActive: "px-master-field-active",
  formQuickEntry: "px-master-field-quick-entry",
  formDisplayOrder: "px-master-field-display-order",
  formContextSurgicalHistory: "px-master-context-surgical-history",
  formContextProcedures: "px-master-context-procedures",
  formSave: "px-master-save-btn",
  formCancel: "px-master-cancel-btn",
  mappingSystem: "px-master-mapping-system",
  mappingCode: "px-master-mapping-code",
  mappingAdd: "px-master-mapping-add",
};

export const SHX = {
  panel: "patient-chart-shx",
  search: "patient-chart-shx-search",
  add: "patient-chart-shx-add",
  results: "patient-chart-shx-results",
  result: "patient-chart-shx-result",
  table: "patient-chart-shx-table",
  row: "patient-chart-shx-row",
  quickEntry: "patient-chart-shx-quick-entry",
  quickChip: "patient-chart-shx-quick-chip",
  review: "patient-chart-shx-review",
  lastReviewed: "patient-chart-shx-last-reviewed",
  close: "patient-chart-shx-close",
  previous: "patient-chart-shx-previous",
  next: "patient-chart-shx-next",
  card: "patient-chart-card-surgical-history",
  viewAll: "patient-chart-view-all-surgical-history",
  title: "patient-chart-shx-title",
  header: "patient-chart-shx-patient-header",
  dateOfService: "patient-chart-shx-dos",
  category: "patient-chart-shx-category",
  sort: "patient-chart-shx-sort",
  selected: "patient-chart-shx-selected",
  changeProcedure: "patient-chart-shx-change-procedure",
  pxCode: "patient-chart-shx-px-code",
  mappings: "patient-chart-shx-mappings",
  viewMappings: "patient-chart-shx-view-mappings",
  datePerformed: "patient-chart-shx-date-performed",
  dateManual: "patient-chart-shx-date-manual",
  laterality: "patient-chart-shx-laterality",
  performer: "patient-chart-shx-performer",
  location: "patient-chart-shx-location",
  comment: "patient-chart-shx-comment",
  reviewedBy: "patient-chart-shx-reviewed-by",
  manageQuickEntry: "patient-chart-shx-manage-quick-entry",
  searchAll: "patient-chart-shx-search-all",
  saveAnother: "patient-chart-shx-save-another",
  saveClose: "patient-chart-shx-save-close",
  view: "patient-chart-shx-view",
  edit: "patient-chart-shx-edit",
  delete: "patient-chart-shx-delete",
};
